import React from 'react'

const Subtitle: React.FC = ({ children }) => {
  return <h4 className="my-6 text-base">{children}</h4>
}

export default Subtitle
